export default "__VITE_ASSET__DwVzCock__"